import React, { Component } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	FormGroup,
	Label,
	Input,
	Row,
	Col,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import moment from "moment";

import {
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
	getProductStockReportList,
} from "../../../store/Reports/actions";
import {
	getMiniLocations,
	getMiniProductGroupsList,
} from "../../../store/Mini/actions";

var date = new Date(),
	y = date.getFullYear(),
	m = date.getMonth();

class ProductStockReports extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {
		this.props.getMiniLocations();
		this.props.getMiniProductGroupsList();
		this.props.SetParams({});
	}

	ReportsChangeHandeler(e) {
		this.props.ReportsChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}

	SelecteChangeValue({ key, label, key2, value }) {
		this.props.ReportsSelecteChangeValue({ key, label, key2, value });
	}

	render() {
		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						<Row>
							<Col md={12}>
								<Card>
									<CardHeader className="bg-transparent border-bottom">
										<Link
											to="/reports"
											className="action-icon text-primary mr-2">
											<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
										</Link>
										<h5 className="card-title-18 pt-2 d-inline-block">
											Product Stock Report
										</h5>
									</CardHeader>
									<CardBody className="pt-1">
										<Row className="p-1">
											<Col md={12}>
												<Card className="p-1">
													<CardBody className="pt-1">
														<Row>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="start_date"
																		className="col-form-label">
																		From Date:
																	</Label>
																	<Input
																		className="form-control"
																		type="date"
																		id="start_date"
																		name="start_date"
																		value={
																			this.props.params?.start_date ||
																			moment(new Date(y, m, 1)).format("YYYY-MM-DD")
																		}
																		onChange={(e) =>
																			this.ReportsChangeHandeler(e)
																		}
																		max={moment(new Date()).format("YYYY-MM-DD")}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="end_date"
																		className="col-form-label">
																		To Date:
																	</Label>
																	<Input
																		className="form-control"
																		type="date"
																		id="end_date"
																		name="end_date"
																		value={
																			this.props.params?.end_date ||
																			moment(new Date()).format("YYYY-MM-DD")
																		}
																		onChange={(e) =>
																			this.ReportsChangeHandeler(e)
																		}
																		min={
																			this.props.params?.start_date ||
																			moment(new Date(y, m, 1)).format("YYYY-MM-DD")
																		}
																		max={moment(new Date()).format("YYYY-MM-DD")}
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="location-select"
																		className="col-form-label">
																		Location:
																	</Label>
																	<Select
																		id="location-select"
																		name="location-select"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={document.body}
																		styles={{
																			menuPortal: (base) => ({
																				...base,
																				zIndex: 9999,
																			}),
																		}}
																		options={this.props.locationslist.map(
																			(item) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this.props.Reportdata?.locationLabel,
																			value: this.props.params?.location,
																		}}
																		onChange={(e) => {
																			this.SelecteChangeValue({
																				key: "locationLabel",
																				label: e?.label,
																				key2: "location",
																				value: e?.value,
																			});
																		}}
																		isClearable
																	/>
																</FormGroup>
															</Col>
															<Col md={3}>
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="group-select"
																		className="col-form-label">
																		Product Group:
																	</Label>
																	<Select
																		id="group-select"
																		name="group-select"
																		classNamePrefix="select2-selection"
																		menuPortalTarget={document.body}
																		styles={{
																			menuPortal: (base) => ({
																				...base,
																				zIndex: 9999,
																			}),
																		}}
																		options={this.props.miniPGroupList.map(
																			(item) => ({
																				label: item.name,
																				value: item.id,
																			})
																		)}
																		value={{
																			label: this.props.Reportdata?.groupLabel,
																			value: this.props.params?.group,
																		}}
																		onChange={(e) => {
																			this.SelecteChangeValue({
																				key: "groupLabel",
																				label: e?.label,
																				key2: "group",
																				value: e?.value,
																			});
																		}}
																		isClearable
																	/>
																</FormGroup>
															</Col>
															<Col md={3} className="mt-1">
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="brand_name"
																		className="col-form-label">
																		Brand Name:
																	</Label>
																	<Input
																		className="form-control"
																		type="text"
																		id="brand_name"
																		name="brand_name"
																		placeholder="Brand Name"
																		value={
																			this.props.params?.brand_name || ""
																		}
																		onChange={(e) =>
																			this.ReportsChangeHandeler(e)
																		}
																	/>
																</FormGroup>
															</Col>
															<Col md={3} className="mt-1">
																<FormGroup className="mb-0">
																	<Label
																		htmlFor="subgroup_name"
																		className="col-form-label">
																		Sub Group:
																	</Label>
																	<Input
																		className="form-control"
																		type="text"
																		id="subgroup_name"
																		name="subgroup_name"
																		placeholder="Sub Group"
																		value={
																			this.props.params?.subgroup_name || ""
																		}
																		onChange={(e) =>
																			this.ReportsChangeHandeler(e)
																		}
																	/>
																</FormGroup>
															</Col>
															<Col md={3} className="mt-1">
																<div>
																	<Label>&nbsp;</Label>
																</div>
																<Link to="/ProductStockReportList">
																	<Button
																		block
																		type="button"
																		color="primary"
																		className="waves-effect waves-light">
																		Generate Report
																	</Button>
																</Link>
															</Col>
														</Row>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { locationslist, miniPGroupList } = state.Mini;
	const { params, Reportdata } = state.reports;
	return {
		locationslist,
		miniPGroupList: miniPGroupList || [],
		params,
		Reportdata,
	};
};

export default connect(mapStatetoProps, {
	getMiniLocations,
	getMiniProductGroupsList,
	SetParams,
	ReportsChangeValue,
	ReportsSelecteChangeValue,
	getProductStockReportList,
})(ProductStockReports);
